<div class="surface-elevated p-plus">
  @if (store()) {
    <div class="store-summary radius-big d-flex flex-column gap-medium p-plus pt-medium surface-high-contrast">
      <div class="d-flex gap-pony">
        <div class="p-pony d-flex justify-content-center align-items-center surface-back radius-minus h-fit-content">
          <ui-api-image
            [imageId]="store()!.logoImageId"
            [width]="'30px'"
            [height]="'30px'"
          ></ui-api-image>
        </div>
        <div class="d-flex flex-column">
          <div class="d-flex gap-pony">
            <span class="st-6 text-onback-high">{{ store()?.title }}</span>
            @for (badge of store()?.badges; track badge.content) {
              <ngx-badge
                [mode]="badge.mode"
                [status]="badge.status"
                >{{ badge.content }}</ngx-badge
              >
            }
          </div>
          <span class="c-3 mb-tiny">{{ store()?.subtitle }}</span>
          <div class="d-flex gap-small align-items-center flex-wrap">
            @for (paymentType of store()?.paymentMethods; track paymentType) {
              <span class="l-3 text-onback-low">
                {{ StorePaymentMethodMapper[paymentType] }}
              </span>
              @if (!$last) {
                <div class="h-divider"></div>
              }
            }
          </div>
        </div>
      </div>
      @if (this.isDisabled()) {
        <div class="d-flex justify-content-center">
          <ngx-badge
            [mode]="'bold'"
            [status]="'error'"
            >این فروشگاه در دیجی‌پی غیرفعال شده است!</ngx-badge
          >
        </div>
      } @else {
        <div class="d-flex gap-small">
          @if (hasShop()) {
            <div class="flex-grow">
              <ngx-button
                [mode]="'section'"
                [style]="'tinted-on-elevated'"
                [size]="'small'"
                [fullWidth]="true"
                (clickHandler)="scrollToAddresses()"
              >
                <span class="bt-2">خرید حضوری</span>
              </ngx-button>
            </div>
          }
          @if (hasWebsite()) {
            <div class="flex-grow">
              <ngx-button
                [mode]="'section'"
                [style]="'fill'"
                [size]="'small'"
                [fullWidth]="true"
                (clickHandler)="goToWebsite()"
              >
                <span>خرید آنلاین</span>
              </ngx-button>
            </div>
          }
        </div>
      }
    </div>
  } @else {
    <div class="store-summary radius-medium d-flex flex-column gap-medium p-plus pt-medium surface-high-contrast">
      <div class="d-flex gap-pony">
        <lib-ngx-skeleton-loading
          [width]="'40px'"
          [height]="'40px'"
        ></lib-ngx-skeleton-loading>
        <div class="d-flex flex-column gap-pony">
          <lib-ngx-skeleton-loading
            [width]="'100px'"
            [height]="'20px'"
          ></lib-ngx-skeleton-loading>
          <lib-ngx-skeleton-loading
            [width]="'200px'"
            [height]="'20px'"
          ></lib-ngx-skeleton-loading>
          <lib-ngx-skeleton-loading
            [width]="'100px'"
            [height]="'20px'"
          ></lib-ngx-skeleton-loading>
        </div>
      </div>
    </div>
  }
</div>
